import { render, staticRenderFns } from "./RemoteManagementIos.vue?vue&type=template&id=c4705742&"
import script from "./RemoteManagementIos.vue?vue&type=script&lang=ts&"
export * from "./RemoteManagementIos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4705742')) {
      api.createRecord('c4705742', component.options)
    } else {
      api.reload('c4705742', component.options)
    }
    module.hot.accept("./RemoteManagementIos.vue?vue&type=template&id=c4705742&", function () {
      api.rerender('c4705742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/rooms/RemoteManagementIos.vue"
export default component.exports